import React from 'react';
import { motion } from 'framer-motion';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Plan de Rescate Financiero de 7 Días',
    desc: 'Tu hoja de ruta de emergencia. Sabés exactamente qué hacer cada día esta semana para salir del caos financiero sin abrumarte.',
    value: '$9.000'
  }, {
    num: '02',
    title: 'Checklist Anti-Fugas de Dinero',
    desc: 'La auditoría de 30 minutos para detectar exactamente por dónde se te va la plata cada mes sin que te des cuenta.',
    value: '$10.000'
  }, {
    num: '03',
    title: 'Guía Express de Presupuesto Anti-Inflación',
    desc: 'El presupuesto pensado para Argentina. Flexible, revisable y diseñado para aguantar subas de precios sin romperse.',
    value: '$8.000'
  }, {
    num: '04',
    title: 'Kit de Decisiones Financieras Inteligentes',
    desc: 'El filtro de 5 preguntas para tomar mejores decisiones con tu plata sin dudar, improvisar ni arrepentirte después.',
    value: '$9.000'
  }, {
    num: '05',
    title: 'Rutina Semanal de Control del Dinero',
    desc: 'El sistema de 15 minutos semanales para mantener tus finanzas bajo control sin esfuerzo ni obsesión.',
    value: '$9.000'
  }, {
    num: '06',
    title: 'Mapa de Metas Financieras Realistas',
    desc: 'Convertí tus ganas de "estar mejor" en objetivos concretos con fecha, número y sistema de seguimiento.',
    value: '$8.000'
  }];
  return <section className="bg-surface py-16 px-4 border-t border-border" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <div className="text-center mb-12" data-id="element-19">
          <h2 className="text-3xl md:text-5xl font-bold text-ink mb-3 font-serif" data-id="element-20">
            🎁 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-lg md:text-xl text-primary font-bold tracking-widest uppercase" data-id="element-21">
            Siempre Incluidos
          </p>
        </div>

        <div className="space-y-4 mb-10" data-id="element-22">
          {bonuses.map((bono, i) => <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} key={i} className="bg-white rounded-xl p-6 flex flex-col md:flex-row items-center border border-border shadow-sm hover:shadow-md transition-shadow" data-id="element-23">
              <div className="flex-shrink-0 w-16 h-16 bg-cream rounded-full flex items-center justify-center text-2xl font-bold text-primary mb-4 md:mb-0 md:mr-6 border border-border" data-id="element-24">
                {bono.num}
              </div>
              <div className="flex-grow text-center md:text-left mb-4 md:mb-0" data-id="element-25">
                <h4 className="text-lg md:text-xl font-bold text-ink mb-2 flex items-center justify-center md:justify-start font-serif" data-id="element-26">
                  <span className="mr-2" data-id="element-27">🎁</span> {bono.title}
                </h4>
                <p className="text-muted text-sm md:text-base font-medium" data-id="element-28">
                  {bono.desc}
                </p>
              </div>
              <div className="flex-shrink-0 text-center md:text-right md:ml-6 bg-surface px-4 py-3 rounded-lg border border-border/50" data-id="element-29">
                <p className="line-through text-sm mb-1 text-muted font-medium" data-id="element-30">
                  Valor: {bono.value}
                </p>
                <p className="text-success font-bold text-xl" data-id="element-31">GRATIS</p>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-primary-dark border-2 border-gold rounded-2xl p-8 text-center shadow-lg" data-id="element-32">
          <p className="text-xl md:text-2xl font-bold text-cream" data-id="element-33">
            Valor total bonos:{' '}
            <span className="text-urgency line-through mx-2" data-id="element-34">$53.000</span>
            <span className="text-gold" data-id="element-35">→ GRATIS</span> con tu Dominio
            Financiero
          </p>
        </div>
      </div>
    </section>;
}